import React, { useState, useRef, useEffect } from "react";
import ArrowDropDownTwoToneIcon from '@mui/icons-material/ArrowDropDownTwoTone';
import CalendarToday from '@mui/icons-material/CalendarToday';
import SearchIcon from '@mui/icons-material/Search';
import { TextField, Typography, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Grid, Card, CardContent, IconButton, Menu, MenuItem } from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import favicon from './assets/MyImg/fevi1.png';
import logo from './assets/MyImg/logo.jpeg';
import logo1 from './assets/MyImg/LoginImgy.png';
import HeaderSection from "./HeaderSection";
import axios from "axios";

const Bill = () => {
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredInvoices, setFilteredInvoices] = useState(invoices);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [selectedDate, setSelectedDate] = useState("");
  const dateInputRef = useRef(null); // Ref for the date input

  const handleViewClick = (invoice) => {
    setSelectedInvoice(invoice);
  };

  const calculateTotalAmount = (products) => {
    return products.reduce((total, product) => total + product.quantity * product.price, 0);
  };

  // Fetch invoices from API
  useEffect(() => {
    axios.get("https://enzo-matr.onrender.com/invoice_bill") // Replace with your backend URL
      .then((response) => {
        setInvoices(response.data);
        setFilteredInvoices(response.data); // Set filtered invoices initially
      })
      .catch((error) => console.error("Error fetching invoices:", error));
  }, []);

  useEffect(() => {
    // Fetch invoice_bills data from the backend
    const fetchInvoices = async () => {
      try {
        const response = await axios.get("https://enzo-matr.onrender.com/api/invoice_bills"); // Ensure the correct endpoint
        setInvoices(response.data);
        setFilteredInvoices(response.data); // Set filtered invoices initially
      } catch (error) {
        console.error("Error fetching invoices:", error);
      }
    };
    fetchInvoices();
  }, []);

  const handlePrint = () => {
    if (!selectedInvoice) {
      alert("No invoice selected to print.");
      return;
    }

    const printContents = `
      <div style="display:flex; width:100%;">
        <img src="${logo1}" alt="Logo" style="text-align: center; width: 60px; height:35px; margin-left: 228px;" />
        <h6 style="text-align: center; font-family: 'source serif pro'; font-size: 24px; font-weight: bold; margin-top: 5px;">
          Enzo Management
        </h6>
      </div>
      <p style="text-align: center; font-family: 'cardo'; font-size: 14px;">Life Changes Ind.</p>
      <div style="display: flex; justify-content: space-between; width: 100%;">
        <p style="text-align: left; font-size: 14px;">Invoice No: ${selectedInvoice.invoiceNo}</p>
        <p style="text-align: right; font-size: 14px;">${selectedInvoice.date}</p>
      </div>
      <table style="width: 100%; border-collapse: collapse;">
        <thead>
          <tr style="background: #eeecec;">
            <th style="border-bottom: 1px solid; border-top: 1px solid; font-weight: bold; font-family: 'source serif pro'; padding: 8px;">Item</th>
            <th style="border-bottom: 1px solid; border-top: 1px solid; font-weight: bold; font-family: 'source serif pro'; padding: 8px;">Qty</th>
            <th style="border-bottom: 1px solid; border-top: 1px solid; font-weight: bold; font-family: 'source serif pro'; padding: 8px;">VAT</th>
            <th style="border-bottom: 1px solid; border-top: 1px solid; font-weight: bold; font-family: 'source serif pro'; padding: 8px;">Rate</th>
            <th style="border-bottom: 1px solid; border-top: 1px solid; font-weight: bold; font-family: 'source serif pro'; padding: 8px;">Amount</th>
          </tr>
        </thead>
        <tbody style="text-align: center">
          ${selectedInvoice.products
        .map(
          (product) => `
            <tr>
              <td style="font-family: 'source serif pro'; padding: 8px;">${product.item || product.name || "N/A"}</td>
              <td style="padding: 8px;">${product.quantity}</td>
              <td style="padding: 8px;">${product.vat}</td>
              <td style="padding: 8px;">${product.price}</td>
              <td style="padding: 8px;">${product.quantity * product.price}</td>
            </tr>
          `
        )
        .join("")}
        </tbody>
      </table>
      <h6 style="text-align: right; border-top: 1px solid; padding-top: 8px;">Total: Rs. ${calculateTotalAmount(selectedInvoice.products)}</h6>
    `;

    const originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
  };

  // Helper to format date as YYYY-MM-DD
  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    if (isNaN(date)) return dateStr; // fallback if invalid
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleSearch = () => {
    const filtered = invoices.filter(invoice =>
      (invoice.invoiceNo && invoice.invoiceNo.includes(searchTerm)) ||
      (invoice.date && formatDate(invoice.date).includes(searchTerm)) ||
      (invoice.detail && invoice.detail.includes(searchTerm)) ||
      (invoice.state && invoice.state.includes(searchTerm))
    );
    setFilteredInvoices(filtered);
  };

  const handleMonthClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMonthClose = (month) => {
    setAnchorEl(null);
    if (month) {
      setSelectedMonth(month);
      const filtered = invoices.filter(invoice => {
        const invoiceMonth = new Date(invoice.date).toLocaleString('default', { month: 'long' });
        return invoiceMonth === month;
      });
      setFilteredInvoices(filtered);
    }
  };

  const handleDateChange = (event) => {
    const date = event.target.value;
    setSelectedDate(date);
    if (date) {
      const filtered = invoices.filter(invoice => {
        // Ensure both are in YYYY-MM-DD format for comparison
        return formatDate(invoice.date) === date;
      });
      setFilteredInvoices(filtered);
    } else {
      setFilteredInvoices(invoices);
    }
  };

  const handleDateButtonClick = () => {
    if (dateInputRef.current) {
      dateInputRef.current.showPicker();
    }
  };

  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  return (
    <>
      <HeaderSection />
      <Paper
        sx={{
          background: "#eeecec",
          overflow: "hidden",
          // Responsive height for Paper
          height: {
            xs: "100vh",   // mobile
            sm: "100%",   // tablet
            md: "89.2vh"   // desktop and up
          },
          marginTop: "-10px"
        }}
      >
        <div style={{
          fontFamily: "caladea", width: "100%", background: "#20a4a3", height: "50px", padding: "4px",
          textAlign: "center", fontSize: "36px", color: "white", lineHeight: "50px", fontWeight: "bold"
        }}>
          BILL HISTORY
        </div>

        <Grid container spacing={2} sx={{
          padding: 2,
          // Remove fixed height for mobile/tablet to allow content to grow
          height: {
            xs: "auto",   // mobile
            sm: "auto",   // tablet
            md: "89.5vh"  // desktop and up
          }
        }}>
          <Grid item xs={12} md={8} sx={{ marginBottom: "2px" }}>
            <Card>
              <CardContent>
                <Grid container spacing={0.5} alignItems="center" sx={{ marginBottom: "5px" }}>
                  <Grid item xs={4.6}>
                    <TextField
                      variant="outlined"
                      placeholder="Search Item"
                      size="small"
                      fullWidth
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        const value = e.target.value.toLowerCase();
                        const filtered = invoices.filter(invoice =>
                          (invoice.invoiceNo && String(invoice.invoiceNo).toLowerCase().includes(value)) ||
                          (invoice.date && formatDate(invoice.date).toLowerCase().includes(value)) ||
                          (invoice.detail && String(invoice.detail).toLowerCase().includes(value)) ||
                          (invoice.state && String(invoice.state).toLowerCase().includes(value))
                        );
                        setFilteredInvoices(filtered);
                      }}
                      InputProps={{
                        sx: {
                          borderRadius: "10px",
                          border: "1px solid",
                          fontSize: {
                            xs: "14px", // mobile
                            sm: "15px", // tablet
                            md: "16px"  // desktop
                          },
                          padding: {
                            xs: "6px 8px", // mobile
                            sm: "8px 12px", // tablet
                            md: "10px 14px" // desktop
                          },
                          height: {
                            xs: "38px", // mobile
                            sm: "40px", // tablet
                            md: "44px"  // desktop
                          }
                        }
                      }}
                      sx={{
                        width: {
                          xs: "100%", // mobile: full width
                          sm: "100%", // tablet: full width
                          md: "100%"  // desktop: full width of grid item
                        },
                        marginRight: {
                          xs: 0,
                          sm: 0,
                          md: 0
                        }
                      }}
                    />
                  </Grid>
                  <Grid item>
                    <IconButton
                      sx={{ background: "black", color: "white", borderRadius: "10px" }}
                      fullWidth
                      onClick={handleSearch}
                    >
                      <SearchIcon />
                    </IconButton>
                  </Grid>
                  <Grid item xs={2.2}>
                    <Button
                      variant="contained"
                      color="primary"
                      endIcon={<ArrowDropDownTwoToneIcon style={{ fontSize: "24px", color: "white" }} />}
                      sx={{
                        background: "#25bdbe",
                        color: "black",
                        border: "1px solid",
                        borderRadius: "10px",
                        fontFamily: "source serif pro",
                        fontSize: "16px",
                        fontWeight: "bold",
                        width: {
                          xs: "100%",   // mobile: full width of grid item
                          sm: "140px",  // tablet: smaller width
                          md: "190px"   // desktop: original width
                        },
                        minWidth: 0,
                        maxWidth: "100%",
                        paddingLeft: { xs: "8px", sm: "12px", md: "16px" },
                        paddingRight: { xs: "8px", sm: "12px", md: "16px" }
                      }}
                      onClick={handleMonthClick}
                    >
                      {selectedMonth ? selectedMonth : "Month"}
                    </Button>
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl)}
                      onClose={() => handleMonthClose(null)}
                    >
                      {months.map((month, index) => (
                        <MenuItem
                          key={index} onClick={() => handleMonthClose(month)}>
                          {month}
                        </MenuItem>
                      ))}
                    </Menu>
                  </Grid>
                  <Grid item xs={2.4}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={handleDateButtonClick}
                      endIcon={<CalendarToday style={{ fontSize: "24px", color: "black" }} />}
                      sx={{
                        background: "#25bdbe",
                        color: "black",
                        border: "1px solid",
                        borderRadius: "10px",
                        fontFamily: "source serif pro",
                        fontSize: "16px",
                        fontWeight: "bold",
                        width: {
                          xs: "100%",   // mobile: full width of grid item
                          sm: "130px",  // tablet: smaller width
                          md: "180px"   // desktop: original width
                        },
                        minWidth: 0,
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        justifyContent: "flex-start",
                        paddingLeft: { xs: "8px", sm: "12px", md: "16px" },
                        paddingRight: { xs: "8px", sm: "12px", md: "16px" }
                      }}
                    >
                      <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: "inline-block",
                        maxWidth: "80px" // Adjust as needed for mobile/tablet
                      }}>
                        {selectedDate ? `${selectedDate}` : "Select Date"}
                      </span>
                      <input
                        type="date"
                        ref={dateInputRef}
                        style={{ display: "flex", width: "0px", height: "0px", backgroundColor: "#25bdbe", border: "none" }}
                        onChange={handleDateChange}
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={1.2}>
                    <Button
                      variant="contained"
                      color="primary"
                      sx={{ background: "#2f2f2f", color: "white", border: "1px solid", borderRadius: "10px", fontFamily: "source serif pro", fontSize: "16px", fontWeight: "bold", width: {
                          xs: "100%",   // mobile: full width of grid item
                          sm: "120px",  // tablet: smaller width
                          md: "178px"   // desktop: original width
                        }, }}
                      onClick={() => {
                        setFilteredInvoices(invoices); // Show all invoices
                        setSelectedMonth(null);        // Reset month filter
                        setSelectedDate("");           // Reset date filter
                        setSearchTerm("");             // Reset search box
                      }}
                    >
                      View All
                    </Button>
                  </Grid>
                </Grid>
                <TableContainer
                  sx={{
                    maxHeight: "60vh",
                    overflowY: "auto",
                    scrollbarWidth: "none", // Firefox
                    msOverflowStyle: "none", // IE/Edge
                    "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
                  }}
                >
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Invoice No
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Date
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Time
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Total Items
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Total Price
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Delivery Type
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          Payment Type
                        </TableCell>
                        <TableCell
                          sx={{
                            color: "white",
                            fontWeight: "bold",
                            backgroundColor: "#2f2f2f",
                            position: "sticky",
                            top: 0,
                            zIndex: 1
                          }}
                        >
                          View
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredInvoices.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell>{row.invoiceNo}</TableCell>
                          <TableCell>{formatDate(row.date)}</TableCell>
                          <TableCell>{row.time}</TableCell>
                          <TableCell>{row.totalItems}</TableCell>
                          <TableCell>{row.totalPrice}</TableCell>
                          <TableCell>{row.deliveryType}</TableCell>
                          <TableCell>{row.paymentType}</TableCell>
                          <TableCell>
                            <IconButton onClick={() => handleViewClick(row)} sx={{ background: "#25bdbe", width: "25px", height: "25px", borderRadius: "5px" }}><img src={favicon} style={{ width: "18px" }} alt="Favicon" /></IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                      {/* Add empty rows to keep table height stable */}
                      {filteredInvoices.length < 8 &&
                        Array.from({ length: 8 - filteredInvoices.length }).map((_, idx) => (
                          <TableRow key={`empty-${idx}`}>
                            <TableCell colSpan={8} sx={{ height: 53, border: 0 }} />
                          </TableRow>
                        ))
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>

          <Grid
  item
  xs={12}
  md={4}
  sx={{
    // Remove fixed height for mobile/tablet
    height: { xs: "auto", sm: "auto", md: "88%" },
    display: "flex",
    flexDirection: "column"
  }}
>
  <Card sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
    <CardContent id="printable-area" sx={{ flex: 1, overflow: "auto" }}>
      <div style={{ display: 'flex', width: '100%' }}>
        <img src={logo} alt="Logo" style={{ width: 60, marginLeft: "100px" }} />
        <Typography variant="h6" sx={{ textAlign: "center", fontFamily: "source serif pro", fontSize: "24px", fontWeight: "bold", mt: '5px' }}> Enzo Management</Typography></div>
      <Typography variant="subtitle2" sx={{ textAlign: "center", fontFamily: "cardo" }}>Life Changes Ind.</Typography>
      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <Typography variant="body2" sx={{ textAlign: "left" }}>Invoice No: {selectedInvoice ? selectedInvoice.invoiceNo : "N/A"}</Typography>
        <Typography variant="body2" sx={{ textAlign: "right" }}>{selectedInvoice ? formatDate(selectedInvoice.date) : "N/A"}</Typography>
      </div>
      <TableContainer sx={{
        overflow: "auto",
        // Responsive height for TableContainer
        height: {
          xs: "25vh",   // mobile
          sm: "30vh",   // tablet
          md: "35vh"    // desktop and up
        }
      }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ background: "#eeecec" }}>
              <TableCell sx={{ borderBottom: "1px solid", borderTop: "1px solid", fontWeight: "bold", fontFamily: "source serif pro" }}>Item</TableCell>
              <TableCell sx={{ borderBottom: "1px solid", borderTop: "1px solid", fontWeight: "bold", fontFamily: "source serif pro" }}>Qty</TableCell>
              <TableCell sx={{ borderBottom: "1px solid", borderTop: "1px solid", fontWeight: "bold", fontFamily: "source serif pro" }}>VAT</TableCell>
              <TableCell sx={{ borderBottom: "1px solid", borderTop: "1px solid", fontWeight: "bold", fontFamily: "source serif pro" }}>Rate</TableCell>
              <TableCell sx={{ borderBottom: "1px solid", borderTop: "1px solid", fontWeight: "bold", fontFamily: "source serif pro" }}>Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selectedInvoice ? (
              selectedInvoice.products.map((product, index) => (
                <TableRow key={index}>
                  <TableCell sx={{ fontFamily: "source serif pro" }}>{product.item || product.name || "N/A"}</TableCell>
                  <TableCell>{product.quantity}</TableCell>
                  <TableCell>{product.vat}</TableCell>
                  <TableCell>{product.price}</TableCell>
                  <TableCell>{product.quantity * product.price}</TableCell> {/* Calculate Amount */}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} sx={{ textAlign: "center" }}>No invoice selected</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography variant="h6" align="right" sx={{ borderTop: "1px solid" }}>
        {selectedInvoice
          ? `Total: Rs. ${calculateTotalAmount(selectedInvoice.products)}`
          : "Rs.0"}
      </Typography>
    </CardContent>
  </Card>
  <Button
    variant="contained"
    color="primary"
    fullWidth
    startIcon={<PrintIcon style={{ fontSize: "36px" }} />}
    sx={{
      marginTop: 1,
      background: "#2f2f2f",
      color: "white",
      height: "94px",
      fontFamily: "caladea",
      fontSize: "36px",
      fontWeight: "bold"
    }}
    onClick={handlePrint}
  >
    PRINT AGAIN
  </Button>
</Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default Bill;